import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { EditableQuestion, Question } from '../model/inaSchoolEnrollments';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { outputAst } from '@angular/compiler';
import { INAAction } from '../../model/ina-action';
import { LoginTokenService } from 'src/app/service/login-token.service';
import { User } from 'src/app/component/auth/model/user.model';
import { first } from 'rxjs';
import { DatePipe, formatDate } from '@angular/common';

@Component({
  selector: 'app-table-edit-comment',
  templateUrl: './table-edit-comment.component.html',
  styleUrls: ['./table-edit-comment.component.scss']
})

export class TableEditCommentComponent implements OnInit {

  @Input('listQuestion') lstEditableQuestions: EditableQuestion[];
  @Input('editing') editing: boolean;
  @Input('type') type!: string;
  @Input('action') action: INAAction;
  @Output() listQuestionChange = new EventEmitter<EditableQuestion[]>();
  @Output() modificationEvent = new EventEmitter<string>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns: string[];
  columnsSchema: any;
  displayedColumnsEdit: string[];
  columnsSchemaEdit: any;

  isSaving: boolean = false;
  comment: string = '';
  service: boolean = false;
  dataSource = new MatTableDataSource<EditableQuestion>();
  constructor(
    public loginTokenService: LoginTokenService,
    private datePipe: DatePipe
  ) {

  }

  ngOnInit(): void {
    if (this.type == 'Comments') {
      this.displayedColumns = CommentNameColumns.filter(x => x.key != 'isEdit').map((col) => col.key);
      this.columnsSchema = CommentNameColumns.filter(x => x.key != 'isEdit');
      this.displayedColumnsEdit = CommentNameColumns.map((col) => col.key);
      this.columnsSchemaEdit = CommentNameColumns;
    }
    else if (this.type == 'Goals') {
      this.displayedColumns = GoalNameColumns.filter(x => x.key != 'isEdit').map((col) => col.key);
      this.columnsSchema = GoalNameColumns.filter(x => x.key != 'isEdit');
      this.displayedColumnsEdit = GoalNameColumns.map((col) => col.key);
      this.columnsSchemaEdit = GoalNameColumns;
    }
    else {
      this.displayedColumns = ServiceNameColumns.filter(x => x.key != 'isEdit').map((col) => col.key);
      this.columnsSchema = ServiceNameColumns.filter(x => x.key != 'isEdit');
      this.displayedColumnsEdit = ServiceNameColumns.map((col) => col.key);
      this.columnsSchemaEdit = ServiceNameColumns;
    }
  }

  ngOnChanges(): void {
    this.dataSource.data = JSON.parse(JSON.stringify(this.lstEditableQuestions));
    this.dataSource.paginator = this.paginator;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  getElementValue(element: EditableQuestion, indexNumber: number): string {
    if (element.question.lstQuestionValueDataView[0].Value.split("|").length > 1)
      return element.question.lstQuestionValueDataView[0].Value.split("|")[indexNumber];

    else

      return "";
  }
  getElementCommentValue(element: EditableQuestion, indexNumber: number): string {
    {
      if (element.question.lstQuestionValueDataView[0].Value.split("|").length == 1)
        return element.question.lstQuestionValueDataView[0].Value.split("|")[0];
      else
        return element.question.lstQuestionValueDataView[0].Value.split("|")[indexNumber];
    }

  }


  editRow(element: EditableQuestion) {
    if (this.dataSource.data.findIndex((x) => x.isEdit == true) === -1) {
      element.isEdit = true;
      this.comment = this.getElementCommentValue(element, 4);
    }
  }
  updateRow(element: EditableQuestion) {
    element.isEdit = false;
    element.isDelete = false;
    var date = new Date();
    let currentDate:string = this.datePipe.transform(date, 'MM/dd/yyy hh:mm a')!
    if (element.question.lstQuestionValueDataView[0].Value == '') {
      let u: User = this.loginTokenService.getUser();
      let firstName = (u?.PERSON?.FIRST_NAME);
      let lastName = (u?.PERSON?.LAST_NAME);
      let userId = (u?.USER_ID);
      let Id = (u?.ID);            
      element.question.lstQuestionValueDataView[0].Value = firstName + "|" + lastName + "|" + userId + "|" + Id + "|" + this.comment + "|" + currentDate;
    }
    else {
      if (element.question.lstQuestionValueDataView[0].Value.split("|").length > 1) {
        let array:Array<string>=element.question.lstQuestionValueDataView[0].Value.split("|")
        array[4]=this.comment;
        array[6]=currentDate;
        let strComment=array.join('|');
        element.question.lstQuestionValueDataView[0].Value=strComment;
      }
      //element.question.lstQuestionValueDataView[0].Value = this.comment;
    }
    this.comment = '';
    this.listQuestionChange.emit(this.dataSource.data);
    this.modificationEvent.emit(element.question.Id.toString())
  }

  removeRow(element: EditableQuestion) {
    if (this.dataSource.data.findIndex((x) => x.isEdit == true) === -1) {
      element.isEdit = true;
      element.isDelete = true;
      this.deleteRow(element)
    }
  }
  disableSubmit(element: EditableQuestion) {

    return this.comment == '';
  }
  cancelRow(element: EditableQuestion) {

    this.comment = '';
    let editableQuestion = this.lstEditableQuestions.find(x => x.question.Id == element.question.Id);
    if (editableQuestion != undefined && editableQuestion.question.lstQuestionValueDataView[0].Value != '') {

      element.question = editableQuestion.question;
      element.isEdit = false;
      element.isDelete = false;
    }
    else {
      this.modificationEvent.emit('cancelled')
    }


  }
  deleteRow(element: EditableQuestion) {
    element.question.lstQuestionValueDataView[0].Value = '';
    this.listQuestionChange.emit(this.dataSource.data);
    this.modificationEvent.emit(element.question.Id.toString())
    //this.dataSource.data = this.dataSource.data.filter(x => x.question.Id == element.question.Id);    
  }
}

export const CommentNameColumns = [
  {
    key: 'isEdit',
    type: 'boolean',
    label: 'Action'
  },
  {
    key: 'comments',
    type: 'text',
    label: 'Comments'
  },
  {
    key: 'createdEdited',
    type: 'date',
    label: 'Created/Edited'
  },


];


export const ServiceNameColumns = [
  {
    key: 'isEdit',
    type: 'boolean',
    label: 'Action'
  },
  {
    key: 'comments',
    type: 'text',
    label: 'Non MEP Service'
  },
  {
    key: 'createdEdited',
    type: 'date',
    label: 'Created/Edited'
  },


];


export const GoalNameColumns = [
  {
    key: 'isEdit',
    type: 'boolean',
    label: 'Action'
  },
  {
    key: 'comments',
    type: 'text',
    label: 'Goals'
  },
  {
    key: 'createdEdited',
    type: 'date',
    label: 'Created/Edited'
  },


];
